import { render, staticRenderFns } from "./HoldButton.vue?vue&type=template&id=1dc146c4&scoped=true"
import script from "./HoldButton.vue?vue&type=script&lang=js"
export * from "./HoldButton.vue?vue&type=script&lang=js"
import style0 from "./HoldButton.vue?vue&type=style&index=0&id=1dc146c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc146c4",
  null
  
)

export default component.exports